import { useSetAtom } from 'jotai'
import React from 'react'

import { brandGroupIdAtom } from '~/atoms'
import { setValueIfExist } from '~/utils'

import {
  brandIdsAtom,
  columnCustomerAttributeIdsAtom,
  columnsDiffsAtom,
  commentBySegmentDisplayTypeAtom,
  customerAttributeIdsAtom,
  dataDisplayTypeAtom,
  hiddenRowIdsAtom,
  questionIdsAtom,
  savedCommentBySegmentDisplayTypeAtom,
  segmentDisplayTypeAtom,
  sortValueAtom,
} from '../../atoms'

import { schema2 } from './schemas/schema2'

const schema = schema2

export const useRestoreParams = () => {
  const setBrandGroupId = useSetAtom(brandGroupIdAtom)

  const setColumnCustomerAttributeIds = useSetAtom(
    columnCustomerAttributeIdsAtom,
  )
  const setBrandIds = useSetAtom(brandIdsAtom)
  const setQuestionIds = useSetAtom(questionIdsAtom)
  const setCustomerAttributeIds = useSetAtom(customerAttributeIdsAtom)
  const setDataDisplayType = useSetAtom(dataDisplayTypeAtom)
  const setSegmentDisplayType = useSetAtom(segmentDisplayTypeAtom)

  const setCommentByKey = useSetAtom(commentBySegmentDisplayTypeAtom)
  const setSavedCommentByKey = useSetAtom(savedCommentBySegmentDisplayTypeAtom)

  const setSortValue = useSetAtom(sortValueAtom)

  const setHiddenRowIds = useSetAtom(hiddenRowIdsAtom)

  const setColumnsDiffs = useSetAtom(columnsDiffsAtom)

  return React.useCallback(
    (state: unknown) => {
      const parsed = schema.safeParse(state)
      if (!parsed.success) {
        return null
      }
      const params = parsed.data

      setValueIfExist(params.brandGroupId, setBrandGroupId)
      setValueIfExist(
        params.columnCustomerAttributeIds,
        setColumnCustomerAttributeIds,
      )
      setValueIfExist(params.brandIds, setBrandIds)
      setValueIfExist(params.questionIds, setQuestionIds)
      setValueIfExist(params.customerAttributeIds, setCustomerAttributeIds)
      setValueIfExist(params.dataDisplayType, setDataDisplayType)
      setValueIfExist(params.segmentDisplayType, setSegmentDisplayType)
      setValueIfExist(params.sortValue, setSortValue)
      setValueIfExist(params.hiddenRowIds, setHiddenRowIds)

      if (params.comment != null) {
        const commentKey = params.segmentDisplayType
        const comment = params.comment
        setCommentByKey((prev) => ({ ...prev, [commentKey]: comment }))
        setSavedCommentByKey((prev) => ({ ...prev, [commentKey]: comment }))
      }

      setValueIfExist(params.columnCustomerAttributesDiffs, setColumnsDiffs)

      return { hash: 'table' }
    },
    [
      setBrandGroupId,
      setBrandIds,
      setColumnCustomerAttributeIds,
      setColumnsDiffs,
      setCommentByKey,
      setCustomerAttributeIds,
      setDataDisplayType,
      setHiddenRowIds,
      setQuestionIds,
      setSavedCommentByKey,
      setSegmentDisplayType,
      setSortValue,
    ],
  )
}
